import {removeHTMLTag, isCompositeCourse} from "@/utils"

export default {
    methods: {
        //大题套小题，小题切换
        switchTabs(e, index) {
            let _dom = e.target
            if (_dom.className.indexOf('actived') < 0) {
                this.setCurrentSmallContent()
                this.smallIndex = index
                this.editorContainer = null
                this.currentFormulaID = ''
            }
        },
        // 插入编辑器内容
        setInnerHtml(curQues) {
            if (this.currentQuestion.smallContent[0].quesTypeID === 4 || this.currentQuestion.smallContent[0].quesTypeID === 5) {
                this.$nextTick(() => {
                    let _html = curQues.attAnswer ? (curQues.userAnswer === null || curQues.userAnswer === '' ? curQues.attAnswer : curQues.userAnswer) : curQues.userAnswer
                    const refName = 'hasChildAnswerArea'
                    this.$refs[refName].innerHTML = (_html === null || _html === 'null') ? '' : _html
                })
            }
        },
        setCurrentSmallContent() {
            if (this.currentQuestion.smallContent[0].quesTypeID === 4 || this.currentQuestion.smallContent[0].quesTypeID === 5) {
                if (this.timerMouseUP) {
                    clearTimeout(this.timerMouseUP)
                }
                let domInput = this.$refs['hasChildAnswerArea']
                let smallContent = this.currentQuestion.smallContent
                let attAnswer = smallContent[this.smallIndex].attAnswer
                // 避免attAnswer里有特殊字符如&times;等时造成将attAnswer与answer判为相等
                var el = document.createElement("div");
                el.innerHTML = attAnswer;
                attAnswer = el.innerHTML;

                let answer = (domInput.innerHTML === '<br/>' || domInput.innerHTML === '<br>' || domInput.innerHTML === 'null' || domInput.innerHTML === null) ? '' : domInput.innerHTML
                //  主观题带有attAnswer判断是否答题
                if (attAnswer) { // 说明有表格题
                    const data = {
                        isAnswer: null,
                        attAnswer: attAnswer, // attAnswer 作为初始化的题目
                        userAnswer: null,
                        index: this.smallIndex
                    }
                    // 是否答题
                    if (answer && (removeHTMLTag(attAnswer) != removeHTMLTag(answer))) {
                        data.isAnswer = 1
                        data.userAnswer = answer
                    }
                    this.$store.dispatch('setAttIsAns', data)
                    this.$store.dispatch('setShortAttAns', data)
                    this.$store.dispatch('setShortAns', data)
                    // 有一道小题已答，则这道大题已答
                    let isAnswer = smallContent.some(item => {
                        return item.isAnswer
                    })
                    this.$store.dispatch('setIsAns', isAnswer ? 1 : 0)
                } else {
                    const data = {
                        isAnswer: answer ? 1 : 0,
                        userAnswer: answer,
                        index: this.smallIndex
                    }
                    //this.$store.dispatch('setAttIsAns', data)
                    this.$store.dispatch('setShortAns', data)
                    let isAnswer = false
                    if (isCompositeCourse(this.siteCourseID, this.courseID)) {
                        //综合 所有小题已做大题才算做
                        isAnswer = smallContent.every(item => {
                            return item.userAnswer
                        })
                    } else {
                        isAnswer = smallContent.some(item => {
                            return item.userAnswer
                        })
                    }
                    this.$store.dispatch('setIsAns', isAnswer ? 1 : 0)
                }
            }
        }
    }
}
